<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="improvedSurveyVo.pkid > 0 ? '编辑' : '新建'"
      class="improvedSurvey-edit"
      width="1200px"
      top="2vh">
    <el-form
        ref="form"
        :model="improvedSurveyVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="投诉单号">
            <el-input v-model="improvedSurveyVo.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="投诉日期" prop="complaintDate">
            <el-date-picker
                v-model="improvedSurveyVo.complaintDate"
                type="date"
                placeholder="选择投诉日期"
                style="width: 100%"
                value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="序列号" prop="serialNo">
            <el-input v-model="improvedSurveyVo.serialNo" placeholder="请输入序列号"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="发生阶段" prop="stage">
            <el-select v-model="improvedSurveyVo.stage" placeholder="请选择发生阶段">
              <el-option label="设计阶段" :value="1"/>
              <el-option label="制造阶段" :value="2"/>
              <el-option label="装配阶段" :value="3"/>
              <el-option label="测试阶段" :value="4"/>
              <el-option label="交付阶段" :value="5"/>
              <el-option label="使用阶段" :value="6"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料号" prop="materialNo">
            <el-input v-model="improvedSurveyVo.materialNo" placeholder="请输入物料号"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="数量" prop="quantity">
            <el-input v-model="improvedSurveyVo.quantity" placeholder="请输入数量"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户" prop="customerName">
            <el-input v-model="improvedSurveyVo.customerName" placeholder="请选择客户" readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.customerSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系方式" prop="contact">
            <el-input v-model="improvedSurveyVo.contact" placeholder="请输入联系方式"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目类型" prop="projectType">
            <el-select v-model="improvedSurveyVo.projectType" placeholder="请选择责任类型">
              <el-option label="新时达责任" :value="1"/>
              <el-option label="供应商责任" :value="2"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="出厂编号" prop="factoryNo">
            <el-input v-model="improvedSurveyVo.factoryNo" placeholder="请输入出厂编号"/>
          </el-form-item>
        </el-col>
        
        <el-col :span="8">
          <el-form-item label="投诉性质" prop="complaintNature">
            <el-select v-model="improvedSurveyVo.complaintNature" placeholder="请选择投诉性质">
              <el-option label="质量投诉" :value="1"/>
              <el-option label="服务投诉" :value="2"/>
              <el-option label="交付投诉" :value="3"/>
              <el-option label="技术投诉" :value="4"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="问题描述" prop="problemDesc">
            <el-input 
                v-model="improvedSurveyVo.problemDesc" 
                type="textarea"
                :rows="2"
                placeholder="请详细描述问题"
                maxlength="1000"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="产品大类" prop="productType">
            <el-input v-model="improvedSurveyVo.productType" placeholder="请输入产品大类"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任类型" prop="dutyType">
            <el-select v-model="improvedSurveyVo.dutyType" placeholder="请选择责任类型">
              <el-option label="新时达责任" :value="1"/>
              <el-option label="供应商责任" :value="2"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任单位" prop="dutyValue">
            <el-input v-model="improvedSurveyVo.dutyValue" placeholder="请输入责任单位"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否重复问题" prop="isRepeatQuestion">
            <el-radio-group v-model="improvedSurveyVo.isRepeatQuestion">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="质量成本" prop="qualityCost">
            <el-input 
                v-model="improvedSurveyVo.qualityCost" 
                placeholder="请输入质量成本"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="投诉等级" prop="complaintGrade">
            <el-select v-model="improvedSurveyVo.complaintGrade" placeholder="请选择投诉等级">
              <el-option label="一般" :value="1"/>
              <el-option label="重要" :value="2"/>
              <el-option label="紧急" :value="3"/>
              <el-option label="重大" :value="4"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">调查分析</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="基准" prop="standard">
            <el-input v-model="improvedSurveyVo.standard" placeholder="请输入基准"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际" prop="practical">
            <el-input v-model="improvedSurveyVo.practical" placeholder="请输入实际值"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="调查结果" prop="surveyResult">
            <el-input 
                v-model="improvedSurveyVo.surveyResult" 
                type="textarea"
                :rows="2"
                placeholder="请输入调查结果"
                maxlength="2000"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      <div class="editTitle">改进措施</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="拦截措施" prop="interceptMeasure">
            <el-input v-model="improvedSurveyVo.interceptMeasure" placeholder="请输入拦截措施"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="拦截措施负责人" prop="interceptHandelName">
            <el-input v-model="improvedSurveyVo.interceptHandelName" placeholder="请输入拦截措施负责人"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="期限" prop="allottedTime">
            <el-date-picker
                v-model="improvedSurveyVo.allottedTime"
                type="datetime"
                placeholder="选择期限"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否改进" prop="isImproved">
            <el-radio-group v-model="improvedSurveyVo.isImproved">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="改进责任人" prop="improvedHandelName">
            <el-input
                v-model="improvedSurveyVo.improvedHandelName"
                placeholder="请选择改进责任人"
                readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="openEmployeeSelect('improvedHandelName')"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="改进描述" prop="improvedNote">
            <el-input 
                v-model="improvedSurveyVo.improvedNote" 
                type="textarea"
                :rows="2"
                placeholder="请输入改进描述"
                maxlength="2000"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="改进措施负责人" prop="improvedMeasureName">
            <el-input
                v-model="improvedSurveyVo.improvedMeasureName"
                placeholder="请选择改进措施负责人"
                readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="openEmployeeSelect('improvedMeasureName')"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="首单执行时间" prop="firstOrderTime">
            <el-date-picker
                v-model="improvedSurveyVo.firstOrderTime"
                type="datetime"
                placeholder="选择首单执行时间"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="措施计划实施时间" prop="interceptPlanTime">
            <el-date-picker
                v-model="improvedSurveyVo.interceptPlanTime"
                type="datetime"
                placeholder="选择措施计划实施时间"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="责任初判" prop="dutyFirst">
            <el-input v-model="improvedSurveyVo.dutyFirst" placeholder="请输入责任初判"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="问题类型" prop="problemType">
            <el-input v-model="improvedSurveyVo.problemType" placeholder="请输入问题类型"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="错误分类" prop="errorClassification">
            <el-select v-model="improvedSurveyVo.errorClassification" placeholder="请选择错误分类">
              <el-option label="设计错误" :value="1"/>
              <el-option label="制造错误" :value="2"/>
              <el-option label="装配错误" :value="3"/>
              <el-option label="检验错误" :value="4"/>
              <el-option label="包装错误" :value="5"/>
              <el-option label="运输错误" :value="6"/>
              <el-option label="安装错误" :value="7"/>
              <el-option label="使用错误" :value="8"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="关联单号" prop="refBillNo">
            <el-input v-model="improvedSurveyVo.refBillNo" placeholder="请输入关联单号"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发运单号" prop="deliveryBillNo">
            <el-input v-model="improvedSurveyVo.deliveryBillNo" placeholder="请输入发运单号"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="销售订单号" prop="salesOrderNo">
            <el-input v-model="improvedSurveyVo.salesOrderNo" placeholder="请输入销售订单号"/>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 物料明细 -->
      <div class="editTitle">物料明细</div>
      <el-button
          type="primary"
          style="margin-bottom: 10px"
          @click="addDetails">
        添加物料
      </el-button>
      <el-table class="tableBox" :data="improvedSurveyVo.materialList" border>
        <el-table-column
            prop="materialNo"
            align="center"
            label="物料编号"
            width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="materialName"
            align="center"
            label="物料名称"
            width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialName"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="quantity"
            align="center"
            label="数量"
            width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.note"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteMaterial(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle">改进措施</div>
      <el-button
          type="primary"
          style="margin-bottom: 10px"
          @click="addReturnDetails">
        添加改进措施
      </el-button>
      <el-table class="tableBox" :data="improvedSurveyVo.detailVOS1" border>
        <el-table-column
            prop="rootCause"
            align="center"
            label="根本原因"
            width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.rootCause"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="measure"
            align="center"
            label="措施"
            width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.measure"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="allottedTime"
            align="center"
            label="期限"
            width="200">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.allottedTime"
                type="datetime"
                placeholder="选择"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
          </template>
        </el-table-column>
        <el-table-column
            prop="type"
            align="center"
            label="改进类型"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.type"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="fileNote"
            align="center"
            label="附件说明"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileNote"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="filePath"
            align="center"
            label="路径"
            width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.filePath"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="verificationResult"
            align="center"
            label="改进措施验证结果"
            width="150">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.verificationResult">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column
            prop="identifier"
            align="center"
            label="改进措施验证人"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.identifier"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="creatorName"
            align="center"
            label="上传人"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.creatorName"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="verificationResult2"
            align="center"
            label="首单验证结果"
            width="140">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.verificationResult2">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column
            prop="identifier2"
            align="center"
            label="首单验证人"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.identifier2"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="question"
            align="center"
            label="问题"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.question"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="isRealReason"
            align="center"
            label="是否真因"
            width="130">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.isRealReason">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column
            prop="dutyName"
            align="center"
            label="责任部门"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.dutyName"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="answer"
            align="center"
            label="答复"
            width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.answer"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteDetailVOS1(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle">附件</div>
      <upload-file
          ref="upload"
          :auth-index="authIndex"
          @upload-success="uploadSuccess"/>
      <el-table
          v-if="improvedSurveyVo.attachments"
          ref="payData1"
          :data="improvedSurveyVo.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.fileName"
                class="tabInput"
                style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="danger" @click="fileDelete(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <employee-select ref="employeeSelect" @select="onSelectEmployee"/>
    <customer-select ref="customerSelect" @select="onSelectCustomer"/>
    <!-- <material-select ref="materialSelect" @select="onSelectMaterial"/> -->
  </el-dialog>
</template>

<script>
  import constants from "@/util/constants";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UploadFile from "@/components/UploadFile";
  // import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";

  export default {
    name: "ImprovedSurveyEdit",
    components: {UploadFile, CustomerSelect, EmployeeSelect},
    data() {
      return {
        constants,
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        employeeType: "", // 选择的类型
        improvedSurveyVo: {
          pkid: 0,
          billNo: "",
          customerId: "",
          customerName: "",
          contact: "",
          salesOrderNo: "",
          note: "",
          attachments: [],
          // 模板中实际使用的字段
          complaintDate: "",
          serialNo: "",
          stage: null,
          materialNo: "",
          quantity: null,
          factoryNo: "",
          problemDesc: "",
          complaintNature: null,
          productType: "",
          dutyType: null,
          dutyValue: "",
          isRepeatQuestion: null,
          qualityCost: null,
          complaintGrade: null,
          standard: "",
          practical: "",
          surveyResult: "",
          interceptMeasure: "",
          interceptHandelName: "",
          allottedTime: "",
          isImproved: null,
          interceptPlanTime: "",
          improvedNote: "",
          firstOrderTime: "",
          dutyFirst: "",
          problemType: "",
          errorClassification: null,
          refBillNo: "",
          deliveryBillNo: "",
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "change"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        // 初始化表单数据
        this.initForm();
        
        if (row && row.pkid) {
          this.improvedSurveyVo.pkid = row.pkid;
          if (this.improvedSurveyVo.pkid > 0) {
            this.getData();
          }
        }
      },
      
      // 新增初始化表单数据方法
      initForm() {
        this.improvedSurveyVo = {
          pkid: 0,
          billNo: "",
          title: "",
          customerId: "",
          customerName: "",
          customerNo: "",
          contact: "",
          // 投诉基本信息
          complaintDate: "",
          serialNo: "",
          stage: null,
          materialNo: "",
          quantity: null,
          factoryNo: "",
          problemDesc: "",
          complaintNature: null,
          productType: "",
          dutyType: null,
          dutyValue: "",
          isRepeatQuestion: null,
          qualityCost: null,
          complaintGrade: null,
          // 调查分析
          standard: "",
          practical: "",
          surveyResult: "",
          // 改进措施
          interceptMeasure: "",
          interceptHandelName: "",
          allottedTime: "",
          isImproved: null,
          interceptPlanTime: "",
          improvedNote: "",
          improvedHandelName: "",
          improvedHandelId: "",
          improvedMeasureName: "",
          improvedMeasureId: "",
          firstOrderTime: "",
          dutyFirst: "",
          problemType: "",
          errorClassification: null,
          // 其他信息
          refBillNo: "",
          deliveryBillNo: "",
          salesOrderNo: "",
          // 数组字段
          details: [],
          attachments: [],
          detailVOS1: [],
          materialList: [],
        };
      },
      // 选择客户
      onSelectCustomer(row) {
        this.improvedSurveyVo.customerNo = row.outerNo;
        this.improvedSurveyVo.customerName = row.customerName;
        this.improvedSurveyVo.customerId = row.customerID;
      },
      // 选择销售员
      onSelectEmployee(row) {
        switch (this.employeeType) {
          case "improvedHandelName":
            // 改进负责人
            this.improvedSurveyVo.improvedHandelId = row.employeeID;
            this.improvedSurveyVo.improvedHandelName = row.employeeName;
            break;
          case "improvedMeasureName":
            // 措施负责人
            this.improvedSurveyVo.improvedMeasureId = row.employeeID;
            this.improvedSurveyVo.improvedMeasureName = row.employeeName;
            console.log(this.improvedSurveyVo.improvedMeasureName);
            break;
        }
      },
      openEmployeeSelect(type) {
        this.employeeType = type;
        this.$refs.employeeSelect.open();
      },
      getData() {
        this.$http
          .get("basic", `improvedSurveys/${this.improvedSurveyVo.pkid}`)
          .then(resp => {
            this.improvedSurveyVo = resp.data;
          });
        this.improvedSurveyVo.attachments.forEach(row => {
          this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
            if (res.success) {
              row.imgUrl = res.data;
              this.imgUrls.push(row.imgUrl);
            }
          });
        });
      },
      // 添加物料明细
      addDetails() {
        this.improvedSurveyVo.materialList.push({
          pkid: 0,
          masterId: 0,
          materialNo: "",
          materialName: "",
          quantity: 1,  // 默认数量为1
          note: "",
        });
      },
      // 添加改进措施明细
      addReturnDetails() {
        this.improvedSurveyVo.detailVOS1.push({
          pkid: 0,
          masterId: 0,
          rootCause: "", // 根本原因
          measure: "", // 措施
          allottedTime: "", // 期限
          type: "", // 改进类型
          fileNote: "", // 附件说明
          filePath: "", // 路径
          verificationResult: null, // 改进措施验证结果
          identifier: "", // 改进措施验证人
          creatorName: "", // 上传人
          verificationResult2: null, // 首单验证结果
          identifier2: "", // 首单验证人
          question: "", // 问题
          isRealReason: null, // 是否真因
          dutyName: "", // 责任部门
          answer: "", // 答复
        });
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.improvedSurveyVo.attachments.push(params);
        }
      },
      // 删除改进措施行
      deleteDetailVOS1(index) {
        this.improvedSurveyVo.detailVOS1.splice(index, 1);
      },
      // 删除物料明细
      deleteMaterial(index) {
        this.improvedSurveyVo.materialList.splice(index, 1);
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.improvedSurveyVo.pkid > 0) {
              this.$http
                .put("basic", "improvedSurveys", this.improvedSurveyVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "improvedSurveys", this.improvedSurveyVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .improvedSurvey-edit{
   .editTitle{
      font-size: 14px;
      font-weight: 600;
      margin: 5px;
      color: #333;
    }
  }
</style>